/* eslint-disable react/prop-types */
import React, { useRef } from "react"
import * as PropTypes from "prop-types"
import { Button, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import useShowSnackbar from "utils/snackbar-hooks"
import useCurrentUser from "utils/auth/useCurrentUser"
import ReceiptOfInvoiceCustomerForm from "./ReceiptOfInvoiceCustomerForm"
import ReceiptOfInvoiceContext from "./ReceiptOfInvoiceContext"
import ReceiptOfInvoiceUserForm from "./ReceiptOfInvoiceUserForm"
import ReceiptOfInvoiceDocumentTable from "./ReceiptOfInvoiceDocumentTable"

const useStyles = makeStyles({
  root: {
    minWidth: 600,
    marginBottom: "20px",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    "& > *": {
      marginLeft: "10px",
      display: "block",
    },
  },
  selectField: {
    width: "100%",
  },
  switchLabel: {
    marginTop: "10px",
  },
  invoicePickerContainer: {
    position: "relative",
    display: "flex",
    flexFlow: "row",
  },
})

export default function ReceiptOfInvoiceForm({
  onCancel,
  onSubmit,
  fetchCustomerData,
  fetchInvoiceData,
  isUpdate,
  defaultValue = {},
  // fetchAllInvoices,
}) {
  const classes = useStyles()
  const currUser = useCurrentUser()

  const [selectedCustomer, setSelectedCustomer] = React.useState(
    defaultValue?.customer ?? null
  )
  // const [selectedInvoices, setSelectedInvoices] = React.useState(
  //   defaultValue?.invoice ?? []
  // )

  console.log({ defaultValue })

  const getInitialInvoices = (dv) => {
    if (!dv) return []

    // prioritas sesuai struktur data kamu
    const raw =
      dv.invoices || // kalau nanti ada banyak invoice
      dv.details || // atau disimpan sebagai details
      dv.documents || // atau documents
      dv.invoice || // kondisi kamu sekarang: single object
      null

    if (!raw) return []

    // kalau sudah array, langsung return, kalau bukan -> jadikan array
    if (Array.isArray(raw)) return raw
    return [raw]
  }

  const [selectedInvoices] = React.useState(() =>
    getInitialInvoices(defaultValue)
  )

  const [showSnackbar] = useShowSnackbar()

  const formProps = {
    isUpdate,
    defaultValue,
  }

  const customerFormRef = useRef()
  const customerForm = (
    <ReceiptOfInvoiceCustomerForm
      ref={customerFormRef}
      fetchCustomerData={fetchCustomerData}
      {...formProps}
    />
  )

  const userFormRef = useRef()
  const userForm = <ReceiptOfInvoiceUserForm ref={userFormRef} {...formProps} />

  const documentTableRef = useRef()
  const documentTable = (
    <ReceiptOfInvoiceDocumentTable
      ref={documentTableRef}
      classes={classes}
      fetchInvoiceData={fetchInvoiceData}
      // fetchAllInvoices={fetchAllInvoices}
      // initialDocuments={defaultValue?.details || []}
      initialDocuments={selectedInvoices}
    />
  )

  const submitForm = async (e) => {
    e.preventDefault()
    try {
      await Promise.all([
        userFormRef.current.submitForm(),
        customerFormRef.current.submitForm(),
        documentTableRef.current.submitForm(),
      ])
    } catch (err) {
      console.log(err)
      return
    }

    const data = {
      ...customerFormRef.current.getFormData(),
      ...userFormRef.current.getFormData(),
      ...documentTableRef.current.getFormData(),
      // userId: currUser.idUser,
    }

    // console.log({ data })
    const { customerId, documents = [] } = data
    const userId = currUser?.idUser

    if (!customerId) {
      showSnackbar("Customer harus diisi")
    }

    if (!userId) {
      showSnackbar("User harus diisi")
      return
    }

    const mapDocFlagsToNames = (doc) => {
      const names = []
      if (doc.fpAsli) names.push("FP Asli")
      if (doc.fpCopy) names.push("FP Copy")
      if (doc.invoiceAsli) names.push("Invoice Asli")
      if (doc.invoiceCopy) names.push("Invoice Copy")
      if (doc.grnAsli) names.push("GRN Asli")
      if (doc.doAsli) names.push("DO Asli")
      if (doc.poCopy) names.push("PO Copy")
      return names
    }

    const docs = documents

    const detailInvoiceIds = docs.map((d) => d.invoiceId)
    const detailAmounts = docs.map((d) =>
      d.amount !== undefined || d.amount !== null ? String(d.amount) : "0"
    )
    const detailDocumentNames = docs.map((d) => mapDocFlagsToNames(d))

    const payload = {
      userId,
      customerId,
      detailInvoiceIds,
      detailAmounts,
      detailDocumentNames,
    }

    console.log("ROI payload:", payload)

    onSubmit(payload)
  }

  return (
    <form onSubmit={submitForm}>
      <Grid container spacing={2}>
        <ReceiptOfInvoiceContext.Provider
          value={{
            selectedCustomer,
            setSelectedCustomer,
            currUser,
          }}
        >
          {userForm}
          {customerForm}
          {documentTable}
        </ReceiptOfInvoiceContext.Provider>
      </Grid>
      <div className={classes.buttonWrapper} style={{ marginTop: "20px" }}>
        <Button variant="outlined" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </div>
    </form>
  )
}

ReceiptOfInvoiceForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fetchCustomerData: PropTypes.func.isRequired,
  fetchInvoiceData: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  defaultValue: PropTypes.object,
}

ReceiptOfInvoiceForm.defaultProps = {
  isUpdate: false,
  defaultValue: {},
}
